var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "block-editor set-department" }, [
    _c("div", { staticClass: "title" }, [_vm._v("Department Selection Type")]),
    _vm._v(" "),
    _c("div", { staticClass: "methods" }, [
      _c(
        "span",
        {
          staticClass: "method",
          class: { selected: _vm.clone.method === "static" },
          on: {
            click: function () {
              return _vm.changeMethod("static")
            },
          },
        },
        [_vm._v("Static")]
      ),
      _vm._v(" "),
      _c(
        "span",
        {
          staticClass: "method",
          class: { selected: _vm.clone.method === "dynamic" },
          on: {
            click: function () {
              return _vm.changeMethod("dynamic")
            },
          },
        },
        [_vm._v("Dynamic")]
      ),
    ]),
    _vm._v(" "),
    _vm.clone.method === "static"
      ? _c("div", { staticClass: "mt-3" }, [
          _c(
            "div",
            { staticClass: "attribute-picker-section" },
            [
              _c("span", { staticClass: "sectionTitle" }, [
                _vm._v(" Choose Department From List"),
              ]),
              _vm._v(" "),
              _c(
                "a-select",
                {
                  staticClass: "select-filetype",
                  attrs: { value: _vm.clone.departmentId },
                  on: { change: _vm.changeDepartment },
                },
                _vm._l(_vm.subjects, function (department) {
                  return _c(
                    "a-select-option",
                    { key: department._id, attrs: { value: department._id } },
                    [
                      _vm._v(
                        _vm._s(_vm.getSubjectTitle(department)) +
                          "\n                "
                      ),
                    ]
                  )
                }),
                1
              ),
            ],
            1
          ),
        ])
      : _c("div", { staticClass: "mt-3" }, [
          _c(
            "div",
            { staticClass: "attribute-picker-section" },
            [
              _c("span", { staticClass: "sectionTitle" }, [
                _vm._v(" Choose Department From Attributes"),
              ]),
              _vm._v(" "),
              _c(
                "a-popover",
                {
                  attrs: {
                    trigger: "click",
                    overlayClassName: "no-padding",
                    placement: "left",
                  },
                  model: {
                    value: _vm.attributePickerVisible,
                    callback: function ($$v) {
                      _vm.attributePickerVisible = $$v
                    },
                    expression: "attributePickerVisible",
                  },
                },
                [
                  _c(
                    "div",
                    { attrs: { slot: "content" }, slot: "content" },
                    [
                      _c("AttributePicker", {
                        attrs: {
                          "default-selected": "department",
                          pick: _vm.onAttributePicked,
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "attribute-input" }, [
                    _c("div", { staticClass: "attribute-input-text-wrapper" }, [
                      _vm.$_.isEmpty(_vm.clone.departmentId)
                        ? _c(
                            "div",
                            { staticClass: "attribute-input-placeholder" },
                            [
                              _vm._v(
                                "\n                            Choose Department From Attributes\n                        "
                              ),
                            ]
                          )
                        : _c(
                            "div",
                            {
                              staticClass: "single-attribute-style",
                              class: { active: _vm.attributePickerVisible },
                            },
                            [
                              _c("AttributeIconPreview", {
                                attrs: { attribute: _vm.clone.departmentId },
                              }),
                              _vm._v(" "),
                              _c("span", [
                                _vm._v(_vm._s(_vm.clone.departmentId)),
                              ]),
                            ],
                            1
                          ),
                    ]),
                    _vm._v(" "),
                    !_vm.$_.isEmpty(_vm.clone.departmentId)
                      ? _c("span", { staticClass: "material-icons" }, [
                          _vm._v(" expand_more "),
                        ])
                      : _vm._e(),
                  ]),
                ]
              ),
            ],
            1
          ),
        ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }